import { render, staticRenderFns } from "./OfferInspirations.vue?vue&type=template&id=55fe3fe1&name=offer-inspirations&"
import script from "./OfferInspirations.vue?vue&type=script&lang=js&"
export * from "./OfferInspirations.vue?vue&type=script&lang=js&"
import style0 from "./OfferInspirations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports